import * as React from 'react';
import LogoImg from '../../../assets/images/logo.png';
import { NavLink } from 'react-router-dom';
import styled, { StyledComponent } from 'styled-components';
export interface LogoProps {
  linkUrl?: string;
  disableLinking?: boolean;
}

const SLogo = styled.div`
  height: 44px;
  background: url(${LogoImg});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  cursor: ${(props: LogoProps) => (props.disableLinking ? 'inherit' : 'pointer')};
  margin: 16px;
`;

export default class Logo extends React.PureComponent<LogoProps, any> {
  public render() {
    return (
      <SLogo {...this.props}>
        {!this.props.disableLinking && <NavLink to={this.props.linkUrl || '/'} />}
      </SLogo>
    );
  }
}
